import src from "IMAGE";
export default { src, width: 257, height: 37, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AJubm42YmJiKpaWlkI+Pj3xbW1tKXFxcS1BQUD5ycnJcFMoO8/Q4M9wAAAAASUVORK5CYII="};
